import { HeadersFunction, LoaderFunctionArgs, MetaArgs } from '@remix-run/node';
import { GetContentPageDocument } from '@theprintbar/graphql';
import { runSudoGraphql } from '@theprintbar/keystone/context';
import { serverEnv } from '@theprintbar/server';
import { contentMeta } from '~/utils/contentMeta';
import { getSiteStructuredData } from '~/utils/getSiteStructuredData';
import { contentPageLoaderResponse } from '../$/utils/getLoaderData';

export function meta(args: MetaArgs<typeof loader>) {
	return [...contentMeta(args), getSiteStructuredData()];
}

export const headers: HeadersFunction = ({ loaderHeaders }) => ({
	'Cache-Control': loaderHeaders.get('Cache-Control') || '',
});

export async function loader({ request }: LoaderFunctionArgs) {
	const { contentPage } = await runSudoGraphql(GetContentPageDocument, { where: { slug: '/' } });

	if (!contentPage) {
		throw new Response('Not Found', { status: 404 });
	}

	return contentPageLoaderResponse(contentPage, request, { webDomain: serverEnv.WEB_DOMAIN });
}

export { default } from '../$/_index';
